module.exports = __webpack_public_path__ + "static/img/7.dc37169.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/5/1/zh/7.png
// module id = xztP
// module chunks = 0